import styled from 'styled-components';
function ExpertBtn() {
  return (
    <Wrap>
      <Expert type="button">
        <a
          href="https://m.expert.naver.com/expert/profile/home?storeId=100001175"
          target="_blank"
          title="Naver Expert"
        >
          Naver 실시간 상담 신청하기
        </a>
      </Expert>
    </Wrap>
  );
}
const Expert = styled.button`
  margin: 0 10px;
  padding: 18px 0;
  width: 50%;
  text-align: center;
  background-size: 25px;
  background-position: 20% 50%;
  border-radius: 5px;
  background-color: #4a65f4;
  box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.4);
  transition: 0.3s;
  &:hover {
    background-color: #22319c;
  }
  a {
    font-size: 22px;
    color: #ffffff;
    display: block;
  }
  @media only screen and (max-width: 992px) {
    width: 90%;
  }
`;
const Wrap = styled.div`
  padding: 100px 0;
  @media only screen and (max-width: 992px) {
    padding: 50px 0;
  }
`;
export default ExpertBtn;
